export function formatPercent(value, { signed = true } = {}) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  const prefix = signed && n > 0 ? '+' : ''
  return `${prefix}${n.toFixed(1)}%`
}

export function formatInteger(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return n.toLocaleString()
}

export function impactTone(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return 'neutral'
  if (n <= -10) return 'critical'
  if (n < 0) return 'warning'
  if (n >= 10) return 'good'
  return 'neutral'
}

export function weatherScoreTone(score) {
  const n = Number(score)
  if (!Number.isFinite(n)) return 'neutral'
  if (n >= 80) return 'good'
  if (n >= 50) return 'warning'
  return 'critical'
}

export function confidenceLabel(score) {
  const n = Number(score)
  if (!Number.isFinite(n)) return 'Low'
  if (n >= 75) return 'High'
  if (n >= 45) return 'Medium'
  return 'Low'
}
